// Shape card details for the `onCardDetailsChange` callback.
// Returns undefined when the wallet gave us nothing to report.
const fetchCardDetails = (fundingSource, network) => {
  if (!fundingSource && !network) return;

  return {
    funding_source: fundingSource?.toLowerCase(),
    brands: [network?.toLowerCase()],
  };
};

export default { fetchCardDetails };
